<template>
  <div class="toggle-switch" :class="`toggle-switch--${color}`">
    <label :for="_uid">
      <input
        :id="_uid"
        type="checkbox"
        class="is-vishidden"
        :checked="value"
        @change="handleInput"
        v-bind="$attrs"
        :aria-label="ariaLabel"
      />

      <span class="toggle-switch__indicator">
        <span class="i"></span>
        <span class="o"></span>
        <span class="switch"></span>
      </span>

      <span class="label">
        <slot name="label"> </slot>

        <template v-if="!$slots.label">
          {{ label }}
        </template>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'green'
    },
    ariaLabel: String
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.checked);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../sass/mixins';

.toggle-switch {
  display: inline-flex;
  min-height: px-to-rem(30px);
}

input:focus-visible ~ .toggle-switch__indicator {
  outline: 0.125rem solid #fff !important;
  outline-offset: 0.125rem;
  -webkit-box-shadow: 0 0 0 0.125rem #0060cc;
  box-shadow: 0 0 0 0.125rem #0060cc;
}

label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-family: $font--bold;

  font-size: px-to-rem(12px);
  line-height: px-to-rem(14px);

  .label {
    display: none;
  }
}

.is-vishidden {
  opacity: 0;
}

.toggle-switch__indicator {
  position: relative;
  background: #565656;
  border-radius: px-to-rem(16px);
  width: px-to-rem(60px);
  height: px-to-rem(32px);
  transition: background-color 0.2s ease-in-out;
  margin-right: px-to-rem(12px);
  .i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    left: px-to-rem(12px);
    height: px-to-rem(10px);
    border: 1px solid $color-white;
  }

  .o {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    right: px-to-rem(8px);
    width: px-to-rem(10px);
    height: px-to-rem(10px);
    border-radius: 50%;
    border: 2px solid $color-white;
  }

  .switch {
    border-radius: 50%;
    background: $color-white;
    position: absolute;
    height: px-to-rem(28px);
    width: px-to-rem(28px);
    margin: px-to-rem(2px);

    transform: none;
    transition: transform 0.2s ease-in-out, height 0.2s ease-in-out,
      margin 0.2s ease-in-out;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.24);
  }
}

//
// States
//
input:checked {
  ~ .toggle-switch__indicator {
    .switch {
      transform: translateX(px-to-rem(28px));
    }

    .toggle-switch--green & {
      background: $ci-color-lightGreen;
    }

    .toggle-switch--orange & {
      background: $ci-color-orange;
    }
  }
}

input:focus {
  ~ .label {
    text-decoration: underline;
  }
}
</style>
